import createIcon from '../../createIcon';

/**
 * @component @name DisplaySettings
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjAgM0g0QzIuODkgMyAyIDMuODkgMiA1VjE3QzIgMTguMSAyLjg5IDE5IDQgMTlIOFYyMUgxNlYxOUgyMEMyMS4xIDE5IDIyIDE4LjEgMjIgMTdWNUMyMiAzLjg5IDIxLjEgMyAyMCAzWk0yMCAxN0g0VjVIMjBWMTdaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNMTQgOC4yNUg2VjkuNzVIMTRWOC4yNVoiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik0xNi41IDkuNzVIMThWOC4yNUgxNi41VjdIMTVWMTFIMTYuNVY5Ljc1WiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTE4IDEyLjI1SDEwVjEzLjc1SDE4VjEyLjI1WiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTcuNSAxNUg5VjExSDcuNVYxMi4yNUg2VjEzLjc1SDcuNVYxNVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const DisplaySettings = createIcon('DisplaySettings', [
  [
    'path',
    {
      d: 'M20 3H4C2.89 3 2 3.89 2 5V17C2 18.1 2.89 19 4 19H8V21H16V19H20C21.1 19 22 18.1 22 17V5C22 3.89 21.1 3 20 3ZM20 17H4V5H20V17Z',
      key: 'a8w85l',
    },
  ],
  ['path', { d: 'M14 8.25H6V9.75H14V8.25Z', key: 'yvmank' }],
  ['path', { d: 'M16.5 9.75H18V8.25H16.5V7H15V11H16.5V9.75Z', key: '1m3u25' }],
  ['path', { d: 'M18 12.25H10V13.75H18V12.25Z', key: '1f09k1' }],
  ['path', { d: 'M7.5 15H9V11H7.5V12.25H6V13.75H7.5V15Z', key: '25e82c' }],
]);

export default DisplaySettings;
